module.exports = __webpack_public_path__ + "img/CZ25778722.9854e257.png";